import Modal from './Modal'
import ModalContainer from './ModalContainer'

export const ModalClose = Modal.Close

export default ModalContainer(Modal)
